import PropTypes from "prop-types";
import React from "react";
import YouTube from "react-youtube";
import { css } from "@emotion/css";

const iframeClass = css({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
});

export default function YouTubeVideo({ block }) {
  const videoId = block.getData().get("videoId");

  return (
    <div
      css={{
        position: "relative",
        "& > div": {
          display: "block",
          position: "relative",
          width: "100%",
          height: 0,
          // https://css-tricks.com/aspect-ratio-boxes/
          paddingBottom: "56.25%",
        },
      }}
    >
      <YouTube
        id={videoId}
        videoId={videoId}
        className={iframeClass.toString()}
        opts={{
          width: "100%",
          height: "100%",
          playerVars: {
            controls: 2,
            modestbranding: 1,
            showinfo: 0,
            wmode: "transparent",
            autohide: 1,
            mode: "opaque",
            rel: 0,
          },
        }}
      />
    </div>
  );
}

YouTubeVideo.propTypes = {
  block: PropTypes.object.isRequired,
};
